import { type MetaItemTranslations, type EventType } from 'models';
import { type Moment } from 'moment/moment';
import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type EventPrivacy } from 'models/privacy';

type RequestMetaItem = {
  name: string;
  translations: MetaItemTranslations;
};

export type RequestVisitData = {
  text_content: string;
  html_content: string;
  start_time: Moment;
  end_time: Moment;
  view_permission: EventPrivacy;
  meta: {
    patient_type?: RequestMetaItem;
    service_type?: RequestMetaItem[];
  };
  post_in_communities: Array<{ id: string }>;
  event_type: EventType;
  description: string;
};

export const requestVisit = async (data: RequestVisitData) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.events.requestVisit, { event: data });
